import { ReactNode } from 'react';
import { RachelScopeProvider } from '../../rachel/contexts/RachelScope.context';
import { useOrderContext } from '../contexts/Order.context';
import { getOrderRachelScope } from '../effects/orderRachelScope';

interface OrderRachelScopeProviderProps {
  children: ReactNode;
}

const OrderRachelScopeProvider = ({ children }: OrderRachelScopeProviderProps) => {
  const orderId = useOrderContext().order?.id;

  return (
    <RachelScopeProvider scope={orderId ? getOrderRachelScope(orderId) : null}>
      {children}
    </RachelScopeProvider>
  );
};

export default OrderRachelScopeProvider;
